export const homepageSliderData = [
  {
    id: 1,
    image: '/sliderImages/admin_block.jpg',
    alt: 'Rayalaseema University Admin Block',
    caption: 'Welcome to Rayalaseema University'
  },
  {
    id: 2,
    image: '/sliderImages/ruk2.jpg',
    alt: 'Rayalaseema University Campus',
    caption: 'Excellence in Education and Research'
  },
  {
    id: 3,
    image: '/sliderImages/slider_1.jpg',
    alt: 'University Campus View',
    caption: 'State-of-the-art Facilities'
  },
  {
    id: 4,
    image: '/sliderImages/vcsir-thiranga.jpeg',
    alt: 'Independence Day Celebration',
    caption: 'Celebrating National Pride'
  },
  {
    id: 5,
    image: '/sliderImages/AC_BLOCK.png',
    alt: 'Academic Block',
    caption: 'Modern Learning Environment'
  }
];

export default homepageSliderData;